import { useEffect, useState } from 'react';

import { SignatureCountry } from '../types';
import {
  checkCiParaguay,
  checkDniArgentina,
  checkDniNieSpain,
  checkNuipColombia,
  checkPersonalIdOtherCountries,
  checkRutChile,
  formatCiParaguay,
  formatDniArgentina,
  formatDniNieSpain,
  formatNuipColombia,
  formatRutChile,
} from '../utils/rutUtils';

export function useNationalIdNumber(initialId: string) {
  const [value, setValue] = useState(initialId);
  const [valid, setValid] = useState(true);
  const [country, setCountry] = useState('');

  const checkNationalIdNumber = (id: string) => {
    switch (country) {
      case 'CL':
        return checkRutChile(id);
      case 'CO':
        return checkNuipColombia(id);
      case 'AR':
        return checkDniArgentina(id);
      case 'PY':
        return checkCiParaguay(id);
      case 'ES':
        return checkDniNieSpain(id);
      default:
        return checkPersonalIdOtherCountries(country, id);
    }
  };

  const formatNationalIdNumber = (id: string) => {
    switch (country) {
      case 'CL':
        return formatRutChile(id);
      case 'CO':
        return formatNuipColombia(id);
      case 'AR':
        return formatDniArgentina(id);
      case 'PY':
        return formatCiParaguay(id);
      case 'ES':
        return formatDniNieSpain(id);
      default:
        return id;
    }
  };

  useEffect(() => {
    setNationalIdNumber(value);
  }, [country]);

  const setNationalIdNumber = (id: string) => {
    const formattedId = formatNationalIdNumber(id);
    setValue(formattedId);
    setValid(checkNationalIdNumber(formattedId));
  };

  return {
    id: { value, valid, country: country as SignatureCountry },
    setNationalIdNumber,
    setCountry,
  };
}
